import { trechoDaSessao } from "./sessao";
/**
 * Integração Almoxarifado ⇆ Portal — navegação entre sistemas com login único
 * (SSO via URL). Os apps rodam localmente em portas diferentes; ao trocar de
 * sistema levamos o usuário logado pela URL (#sso=...) para não pedir login de novo.
 *
 * Portas da SERCAMP (faixa 4001-4005; não colidem com a NX ENERGY que usa
 * 3000/3001/3002): RH = 4001 · DP = 4002 · Qualidade = 4003 ·
 * Almoxarifado = 4004 · Planejamento = 4005 · Portal = 8080.
 */
/** URL do Portal: localhost em dev; apex do dominio em producao (sem hardcode do dominio). */
function portalHost(): string {
  if (typeof window !== "undefined") {
    const h = window.location.hostname;
    const isLocal = h === "localhost" || h === "127.0.0.1" || h === "::1";
    if (!isLocal) {
      // O Portal fica no apex; este sistema esta num subdominio -> remove o 1o rotulo.
      const root = h.replace(/^www\./, "").split(".").slice(1).join(".") || h;
      return `${window.location.protocol}//${root}`;
    }
  }
  return "http://localhost:8080";
}
export const SYSTEMS = {
  portal: portalHost(),
  almoxarifado: "http://localhost:4004",
} as const;

/** Lê o usuário vindo do Portal/outro sistema pela URL (#sso=...). */
export function readSsoUser(): string | null {
  const m = window.location.hash.match(/(?:^|[#&])sso=([^&]+)/);
  return m ? decodeURIComponent(m[1]) : null;
}

/** Remove o token SSO da URL após o login (deixa a barra de endereço limpa). */
export function clearSsoFromUrl() {
  if (window.location.hash.includes("sso=")) {
    history.replaceState(null, "", window.location.pathname + window.location.search);
  }
}

/** Navega para outro sistema levando o usuário logado (login único). */
export function goToSystem(url: string, user: string | null) {
  window.location.href = user ? `${url}/#sso=${encodeURIComponent(user)}${trechoDaSessao()}` : url;
}
